/**
 * @file add.ts
 * @author James Bennion-Pedley
 * @brief Add A to B
 * @date 05/06/2023
 *
 * @copyright Copyright (c) 2023
 *
 */

/*-------------------------------- Imports -----------------------------------*/

import type { PlottyComponent } from "$lib/types/plotty";
import { Add } from "@svicons/ionicons-outline";

/*-------------------------------- Component ---------------------------------*/

const c: PlottyComponent = {
    name: "add",
    category: 'core',
    ui: {
        icon: Add,
    },
    inPorts: {
        a: {
            datatype: "number",
        },
        b: {
            datatype: "number",
        },
    },
    outPorts: {
        out: {},
    },
    process: (input, output) => {
        // TODO add implementation
    },
    init: async (resolve, reject, context) => {
        resolve();
    },
};

/*-------------------------------- Exports -----------------------------------*/

export default c;
